module.exports = __webpack_public_path__ + "static/modal-64a65ee2ef0e96638068553a81ca1079.png";